import { Link, useLocation } from "react-router-dom";
import { APP_STORE_URL, GOOGLE_FORM_URL, INSTAGRAM_URL, NAV_LINKS, PLAY_STORE_URL } from "@/constants/site";

const EXTERNAL_LINKS = [
  {
    slug: "instagram",
    label: "Instagram",
    href: INSTAGRAM_URL,
    aria: "Splurge Finance on Instagram (opens in a new tab)",
  },
  {
    slug: "join-team",
    label: "Join the Team",
    href: GOOGLE_FORM_URL,
    aria: "Apply to join the Splurge social media and marketing team (opens in a new tab)",
  },
  {
    slug: "app-store",
    label: "App Store",
    href: APP_STORE_URL,
    aria: "Splurge Finance on the App Store (opens in a new tab)",
  },
  {
    slug: "google-play",
    label: "Google Play",
    href: PLAY_STORE_URL,
    aria: "Splurge Finance on Google Play (opens in a new tab)",
  },
];

export const Footer = () => {
  const location = useLocation();
  const anchorPrefix = location.pathname === "/" ? "" : "/";
  return (
    <footer className="border-t border-splurge-lavender bg-white">
      <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
          <div>
            <Link
              to="/"
              data-testid="footer-logo"
              aria-label="Splurge Finance home"
              className="flex items-center gap-2.5"
            >
              <img
                src="/logo.png"
                alt=""
                aria-hidden="true"
                className="h-10 w-10 rounded-full ring-1 ring-splurge-lavender"
              />
              <span className="text-xl font-extrabold tracking-tight text-splurge-ink">
                splurge<span className="text-splurge-primary">.</span>
              </span>
            </Link>
            <p className="mt-4 max-w-xs text-sm font-medium text-splurge-ink/50">
              Student-first financial awareness.
            </p>
          </div>

          <nav aria-label="Footer navigation">
            <ul className="flex flex-wrap gap-x-8 gap-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.id}>
                  <Link
                    to={`${anchorPrefix}#${link.id}`}
                    data-testid={`footer-link-${link.id}`}
                    className="text-sm font-semibold text-splurge-ink/65 transition-colors hover:text-splurge-primary"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/blog"
                  data-testid="footer-link-blog"
                  className="text-sm font-semibold text-splurge-ink/65 transition-colors hover:text-splurge-primary"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to={`${anchorPrefix}#press-kit`}
                  data-testid="footer-link-press-kit"
                  className="text-sm font-semibold text-splurge-ink/65 transition-colors hover:text-splurge-primary"
                >
                  Press Kit
                </Link>
              </li>
              {EXTERNAL_LINKS.map((link) => (
                <li key={link.slug}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`footer-link-${link.slug}`}
                    aria-label={link.aria}
                    className="text-sm font-semibold text-splurge-ink/65 transition-colors hover:text-splurge-primary"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="mt-12 border-t border-splurge-lavender pt-6">
          <p className="text-sm font-medium text-splurge-ink/45">© 2026 Splurge Finance</p>
        </div>
      </div>
    </footer>
  );
};
